import { imgPath } from '~commonInfra/utils/ImgUrl';
import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IDetailFetcher } from '~src/httpClient/fetchers/IDetailFetcher';
import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { WebClientDetailFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientDetailFetcher';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { FieldValuesQuery } from '~src/httpClient/resources/FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from '~src/httpClient/resources/Resource';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import { GetFieldValuesRequest } from '~src/httpClient/serverApi/requests/GetFieldValuesRequest';
import { IFieldValue } from '~src/httpClient/serverApi/types/IFieldValue';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { IPredictiveModelDetailInfo,IPredictiveModelInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';
import { PredictiveModelMapper } from '~src/predictiveModel/models/mappers/PredictiveModelMapper';
import { GetPredictiveModelActionsRequest } from '~src/predictiveModel/serverApi/requests/GetPredictiveModelActionsRequest';
import {
  GetPredictiveModelByLuidRequest
} from '~src/predictiveModel/serverApi/requests/GetPredictiveModelByLuidRequest';
import { GetPredictiveModelDraftIDRequest } from '~src/predictiveModel/serverApi/requests/GetPredictiveModelDraftIDRequest';
import { GetPredictiveModelsRequest } from '~src/predictiveModel/serverApi/requests/GetPredictiveModelsRequest';
import { SetPredictiveModelNameRequest } from '~src/predictiveModel/serverApi/requests/SetPredictiveModelNameRequest';

import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { DeletePredictiveModelsRequest } from '../serverApi/requests/DeletePredictiveModelsRequest';
import { IPredictiveModelActions } from '../serverApi/types/IPredictiveModelActions';

class PredictiveModelsResource implements IListResource<IPredictiveModelInfo>, IFieldValuesResource, IDetailResource<IPredictiveModelDetailInfo>, IActionResource<IPredictiveModelActions> {

  private listFetcher: IListFetcher<IPredictiveModelInfo> = new WebClientListResourceFetcher(GetPredictiveModelsRequest, ServerApiMapper.predictiveModels);
  private detailFetcher: IDetailFetcher<IPredictiveModelDetailInfo> = new WebClientDetailFetcher('getPredictiveModel', PredictiveModelMapper.mapDetail);
  private fieldValuesFetcher: IListFetcher<IFieldValue> = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<IPredictiveModelInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<IPredictiveModelDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public getByLuid(luid: string): Promise<IPredictiveModelDetailInfo> {
    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new GetPredictiveModelByLuidRequest({
      luid: luid,
    }));
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'predictiveModel');
  }

  // Actions
  public actions(id: string): Promise<IPredictiveModelActions> {
    return WebHttpClient.sendRequest(new GetPredictiveModelActionsRequest(id));
  }

  public deletePredictiveModels(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeletePredictiveModelsRequest(idsBlock)),
      ResultHelper.combineResults
    );
  }

  public rename(id: string, name: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new SetPredictiveModelNameRequest({
      id: id,
      name: name
    }));
  }

  public getPredictiveModelDraftID(flowID?: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(new GetPredictiveModelDraftIDRequest({
      flowID: flowID
    }));
  }

  public getPredictiveModelsIconPath(headerIcon: boolean = true): string {
    if (headerIcon) {
      return imgPath(`spaces_masthead_predictive_model.svg`);
    } else {
      return imgPath('einstein_icon_18x18.svg');
    }
  }
}

export const PredictiveModels = new PredictiveModelsResource();
